export const GambleService = { getTry, getWin, getHistory }

function getTry(){
  const  rest = game.models.GambleModel.get().rest
  const settingTry = game.models.GambleModel.getMaxTries()

  return rest == null ? settingTry : rest
}

function getWin(){
  return  game.models.GambleModel.get().win
}

function getHistory(){
  return  game.models.GambleModel.get().history
}
